.ship-from-container {
  width: 100%;
}

.rate-browser-icon {
  padding: 0;
  height: 20px;
  width: 15px;
  border-radius: 4px;

  color: var(--grey-600);
}
